import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const GridViewSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default GridViewSVG;
